import React, {useEffect, useState} from 'react';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import _ from 'lodash';
import {useLazyQuery} from '@apollo/client';
import { useToasts } from "react-toast-notifications";
import { GET_SUMMARY_STOCK } from '../../graphql/totalSummary/query';

const SummaryStock = ({systems, pages, date, setIsLoading}) => {
    const { addToast } = useToasts();
    const [tableData, setTableData] = useState([]);
    //* Query ***
    const [getSummaryStock, { data: summaryStockData, loading: loadingSummaryStock }] = useLazyQuery(GET_SUMMARY_STOCK, {
        fetchPolicy: 'cache-and-network',
    });

    //* useEffect ***
    useEffect(() => {
        if(!_.isEmpty(systems?.amount)|| !_.isEmpty(pages?.amount) || !_.isEmpty(date.createdAt_lt)) {
            setTimeout(() => {
                handleSummaryStock();
            }, 1000);
        }
    }, [systems, pages, date]);

    useEffect(() => {
        if(!_.isEmpty(summaryStockData)) {
            const summaryStock = summaryStockData?.getSummaryStock;
            const newSummaryStock = JSON.parse(summaryStock);
            if(newSummaryStock[0].length > 0) {
                setTableData(newSummaryStock[0]);
            }
        }
    }, [summaryStockData]);

    useEffect(() => {
        if(loadingSummaryStock) setIsLoading((prev) => ({...prev, loadingSummaryStock: true}));
    }, [loadingSummaryStock]);

    //* Function ****
    const handleSummaryStock = async () => {
        if (loadingSummaryStock) return;
        try {
            let where = {}
            if(!_.isEmpty(systems?.listName)) where = {...where, systems: systems?.listName.split(', ')};
            if(!_.isEmpty(pages?.listId)) where = {...where, pages: pages?.listId.split(', ')};
            if(!_.isEmpty(date?.createdAt_gte) && !_.isEmpty(date?.createdAt_lt)) {
                where = {...where, 
                    createdAt_gte: date?.createdAt_gte,
                    createdAt_lt: date?.createdAt_lt
                };
            }

            handleCloseState();
            await getSummaryStock({variables: { where }});
            setIsLoading((prev) => ({...prev, loadingSummaryStock: false}));
        } catch (error) {
            handleCloseState();
            setIsLoading((prev) => ({...prev, loadingSummaryStock: false}));
            console.log("handleSummaryStock error: ", error);
            if (error.message){
                console.log("1 handleSummaryStock error: ", error.message);
                addToast("ບໍ່ພົບຂໍມູນ", {
                    appearance: "warning",
                    autoDismiss: true,
                });
            } else{
                console.log("2 handleSummaryStock error: ", error.message);
                addToast("ມີຂໍຜີດຜາດທີ່ບໍ່ຄາດຄີດສຳລັບ ຍອດເງີນ", {
                    appearance: "error",
                    autoDismiss: true,
                });
            }
        }
    };
    const handleCloseState = () => {
        setTableData([]);
    }
    return (
        <>
            <Table responsive bordered hover className="mb-4"> {/* //! summary all stock */}
                    <thead className="bg-light">
                    <tr>
                        <th colSpan="8" className="text-center">ຍອດສີນຄ້າທັງຫມົດ</th>
                    </tr>
                    <tr>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}></th>
                        <th style={{ color: '#0d6efd', minWidth: '100px' }}>ຈຳນວນສີນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ໂດລາ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ໂດລາ)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {_.isEmpty(tableData)? (
                        <tr>
                            <td colSpan={8} className='text-center'>
                                {loadingSummaryStock ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                            </td>
                        </tr>
                    ) : (
                        tableData.map((row, index) => (
                            <tr key={index}>
                            <td style={{ color: '#0d6efd' }}>{row?.label}</td>
                            <td>{row?.amount.toLocaleString('en-US')}</td>
                            <td>{row?.targetKip.toLocaleString('en-US')}</td>
                            <td>{row?.saleKip.toLocaleString('en-US')}</td>
                            <td>{row?.targetBaht.toLocaleString('en-US')}</td>
                            <td>{row?.saleBaht.toLocaleString('en-US')}</td> 
                            <td>{row?.targetUsd.toLocaleString('en-US')}</td>
                            <td>{row?.saleUsd.toLocaleString('en-US')}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
            </Table>
        </>
    );
};
export default SummaryStock
